// Esqueletos de carga: la forma de lo que viene, en vez de un "Cargando…".
//
// Importan por dos motivos. En 3G la espera es larga y ver la silueta de la
// pantalla la hace sentir más corta. Y —el motivo grave— sin esqueleto varias
// pantallas mostraban el ESTADO VACÍO mientras cargaban: "Todavía no derivaste
// ningún equipo" antes de saberlo. Un cartel que miente medio segundo es peor
// que uno feo: el usuario alcanza a leerlo y duda de sus datos.
// Regla: el estado vacío se muestra SOLO cuando el servidor confirmó vacío.

/** El ladrillo: un bloque que late. Las medidas van por className. */
export function Hueso({ className = "" }: { className?: string }) {
  return <div aria-hidden className={`bg-white/6 rounded animate-pulse ${className}`} />;
}

/** Fila tipo tarjeta de lista: avatar + dos renglones. */
export function EsqueletoFila() {
  return (
    <div className="rounded-xl bg-[#1A2123] border border-white/10 p-4 flex items-center gap-3">
      <Hueso className="w-11 h-11 !rounded-full flex-none" />
      <div className="flex-1 space-y-2">
        <Hueso className="h-3.5 w-2/5" />
        <Hueso className="h-3 w-3/5" />
      </div>
    </div>
  );
}

/** Lista de filas, con aria para que el lector de pantalla sepa que carga. */
export function EsqueletoLista({ filas = 4 }: { filas?: number }) {
  return (
    <div className="flex flex-col gap-2" aria-busy="true" aria-label="Cargando">
      {Array.from({ length: filas }, (_, i) => <EsqueletoFila key={i} />)}
    </div>
  );
}

/** Encabezado de pantalla: título + bajada. */
export function EsqueletoTitulo() {
  return (
    <div className="space-y-2.5" aria-hidden>
      <Hueso className="h-7 w-48" />
      <Hueso className="h-3.5 w-64" />
    </div>
  );
}

/** Grilla de números (estadísticas, métricas). */
export function EsqueletoCifras({ cifras = 4 }: { cifras?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" aria-busy="true" aria-label="Cargando">
      {Array.from({ length: cifras }, (_, i) => (
        <div key={i} className="rounded-xl bg-[#1A2123] border border-white/10 p-4 space-y-2">
          <Hueso className="h-6 w-16" />
          <Hueso className="h-3 w-24" />
        </div>
      ))}
    </div>
  );
}

/** Bloque grande (panel, formulario, ficha). */
export function EsqueletoPanel({ alto = "h-40" }: { alto?: string }) {
  return <Hueso className={`rounded-2xl ${alto} w-full`} />;
}
